const CompetitionService = require('../../services/competition-service.js');

Vue.component('competition-settings', {
  props: ['competitor_limit', 'num_competitors', 'context', 'competitor_teams'],
  computed: {
    canAddCompetitors() {
      return this.num_competitors < this.competitor_limit;
    },
    editForm() {
      return !this.name;
    },
    hasCompetitorsLimit() {
      return true;
    },
    remainingCompetitors() {
      return this.competitor_limit - (this.num_competitors + this.addedCompetitors);
    },
    zeroComp() {
      return this.remainingCompetitors == this.competitor_limit;
    },
  },
  watch: {
    autocompleteResult(val) {
      this.name = val.name || '';
      this.trip_advisor_link = val.url;
    },
  },
  data() {
    return {
      selectedTab: 'findByLink',
      autocompleteResult: {},
      trip_advisor_link: '',
      name: '',
      busy: false,
      adding: false,
      compNames: [],
      suggested: null,
      status_message: {
        status: null,
        value: null,
      },
      errors: [],
      addedCompetitors: 0,
    };
  },
  mounted() {
    this.compNames = [];

    for (let comp of this.competitor_teams) {
      this.compNames.push(comp.name);
    }

    if (this.competitor_teams.length < this.competitor_limit) {
      this.getSuggested();
    }
  },
  methods: {
    openSupport() {
      if (typeof $crisp !== 'undefined') {
        $crisp.push(['do', 'chat:open']);
      }
    },
    setTab(tab) {
      this.selectedTab = tab;
    },
    closeSettings() {
      this.$eventHub.$emit('closeSettings', true);
    },
    getSuggested() {
      // Stash changes for now
      return;

      axios.get('/api/competitors/' + Spark.state.currentTeam.id + '/suggested').then((response) => {
        this.suggested = response.data;
      });
    },
    addSuggestedCompetitor(name, id) {
      let payload = {
        name: name,
        listing_id: id,
      };

      this.adding = true;
      this.name = name;

      axios
        .post('/api/competitors/' + Spark.state.currentTeam.id + '/addCompetitor', payload)
        .then((response) => {
          if (response.data.hasOwnProperty('status') && response.data.status == 'success') {
            this.compNames.push(name);
            this.$eventHub.$emit('updateCompetitors', true);
            this.addedCompetitors++;
            this.trip_advisor_link = '';
            this.name = '';
            this.status_message.status = 'success';
            this.status_message.value = response.data.message;
            this.addedCompetitors++;
            this.$eventHub.$emit('updateCompetitors', true);
          } else if (response.hasOwnProperty('_error_')) {
            console.log(response._error_.message);
            this.status_message.status = 'error';
            this.status_message.value = response._error_.message;
          }
		  this.adding = false;
        })
        .catch((e) => {
          this.status_message.status = 'error';
          this.status_message.value = 'Something went wrong';
		  this.adding = false;
        })
    },

    checkCompetitor(e) {
      var tripAdvisorLink = '';
      try {
        tripAdvisorLink = e.clipboardData.getData('text');
      } catch (error) {
        tripAdvisorLink = this.trip_advisor_link;
      }

      this.busy = true;
	  console.log(tripAdvisorLink);
      CompetitionService.checkCompetitorExists(Spark.state.currentTeam.id, tripAdvisorLink)
        .then(({name}) => {
          this.trip_advisor_link = tripAdvisorLink;
          this.name = name;
		  this.busy = false;
        })
        .catch((err) => {
          this.status_message.status = 'error';
          this.status_message.value = err.message;
          this.trip_advisor_link = '';
		  this.busy = false;
        })
    },

    addCompetitor() {
      let payload = {
        trip_advisor_link: this.trip_advisor_link,
        name: this.name,
      };
      this.adding = true;

      axios.post(`/api/competitors/${Spark.state.currentTeam.id}/addCompetitor`, payload).then((response) => {
        this.adding = false;
        if (response.data.hasOwnProperty('status') && response.data.status == 'success') {
          analytics.track('Added New Competitor', {
            trip_advisor_link: this.trip_advisor_link,
            from_page: this.context,
          });

          // Empty form input on success
          this.trip_advisor_link = '';
          this.name = '';
          this.status_message.status = 'success';
          this.status_message.value = response.data.message;
          this.addedCompetitors++;
          this.$eventHub.$emit('updateCompetitors', true);
        } else if (response.data.hasOwnProperty('_error_')) {
          console.log(response.data._error_.message);
          this.status_message.status = 'error';
          this.status_message.value = response.data._error_.message;
        }
      });
    },

    send() {
      if (this.name == '') return this.checkCompetitor();
      return this.addCompetitor();
    },
  },
});
